// @ts-strict-ignore
import React from 'react'

import { connect } from 'react-redux'
import Icon from 'react-native-vector-icons/MaterialIcons'

import PatientActions from 'APP/Redux/PatientRedux'

// services
import I18n from 'APP/I18n'

// components
import InfoCard from 'APP/Components/InfoCard'

// Styling
import { useTheme } from 'styled-components/native'
import { Dispatch } from 'redux'
import { RootState } from 'APP/Store/CreateStore'

type ZeroEligibilityInfoCardProps = {
  busy: boolean
  unchallengedInvitationSearch: () => void
  testId?: string
}

const _ZeroEligibilityInfoCard = ({
  busy,
  unchallengedInvitationSearch,
  testId,
}: ZeroEligibilityInfoCardProps) => {
  const analyticsName = 'Zero Eligibility'

  const theme = useTheme()

  return (
    <InfoCard
      title={I18n.t('ZeroEligibilityInfoCard.title')}
      subtitle={I18n.t('ZeroEligibilityInfoCard.subtitle.todayScreen')}
      buttonText={I18n.t('ZeroEligibilityInfoCard.button')}
      onButtonPressed={unchallengedInvitationSearch}
      buttonAnalyticsName={analyticsName}
      icon={
        <Icon name="lock-outline" size={40} color={theme.colors.accent} accessibilityRole="image" />
      }
      busy={busy}
      testId={testId}
    />
  )
}

const mapStateToProps = ({ patient }: { patient: RootState }) => {
  return {
    busy:
      (patient?.unchallengedInvitationSearchRunning ?? false) ||
      (patient?.challengedInvitationSearchRunning ?? false),
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    unchallengedInvitationSearch: () =>
      dispatch(PatientActions.unchallengedInvitationSearchRequest()),
  }
}

const ZeroEligibilityInfoCard = connect(
  mapStateToProps,
  mapDispatchToProps
)(_ZeroEligibilityInfoCard)

export default ZeroEligibilityInfoCard
